/**
 * Reserve the inline formatting toolbar's exact footprint while the lazy Plate
 * chunk resolves. Without it the real toolbar pops in ~half a second after the
 * body and shoves everything below it down, so entering edit feels laggy.
 * Mirrors PlateNoteEditorImpl's inline toolbar strip (mt-2 py-2 border-t, four
 * size-7 mark buttons, a divider, three size-7 list/quote buttons) so the real
 * toolbar swaps in at the identical height with no shift.
 *
 * Shared by every host of the seamless inline editor (`PlateNoteEditor`
 * `variant='inline'` with a fallback): the full memo view (MemoForm.tsx) and
 * the task Description editor. Extracted from MemoForm.tsx so the two can't
 * drift — if PlateNoteEditorImpl's toolbar changes shape, this is the single
 * mirror to update.
 */

const INLINE_TOOLBAR_SKELETON_MARKS = ['bold', 'italic', 'underline', 'strike'];
const INLINE_TOOLBAR_SKELETON_BLOCKS = ['bullet', 'number', 'quote'];

export function InlineToolbarSkeleton() {
  return (
    <div
      aria-hidden
      className='mt-2 flex items-center gap-0.5 border-t border-[var(--color-border-secondary)] py-2'
    >
      {INLINE_TOOLBAR_SKELETON_MARKS.map(key => (
        <div
          key={key}
          className='size-7 rounded-md bg-[var(--color-bg-secondary)]'
        />
      ))}
      <div className='mx-1 h-4 w-px bg-border-primary' />
      {INLINE_TOOLBAR_SKELETON_BLOCKS.map(key => (
        <div
          key={key}
          className='size-7 rounded-md bg-[var(--color-bg-secondary)]'
        />
      ))}
    </div>
  );
}
